import SearchWorkspace from '@/components/google-ads/search/SearchWorkspace';
import { TRAFFIC_OBJECTIVE } from './trafficObjective';

/** WEBSITE TRAFFIC WORKSPACE — /google-ads/traffic */
export default function TrafficPage() {
  return <SearchWorkspace objective={TRAFFIC_OBJECTIVE} />;
}
